jQuery(function($){
    $('.load-more').click(function(){

        var button = $(this),
            data = {
                'action': 'loadmore',
                'query': load_more_params.posts,
                'page' : load_more_params.current_page,
                'nonce': load_more_params.nonce
            };

        $.ajax({ // you can also use $.post here
            url : load_more_params.ajaxurl,
            data : data,
            type : 'POST',
            beforeSend : function ( xhr ) {
                button.addClass('loading');
            },
            success : function( data ){
                if( data ) {
                    button.removeClass( 'loading' ).parent().prev().after(data);
                    load_more_params.current_page++;

                    if ( load_more_params.current_page == load_more_params.max_page )
                        button.remove();
                } else {
                    button.remove();
                }
            }
        });
    });
});